/*
 * Sticky cart – floating basket button.
 * Shows when the cart has items and the page is scrolled past the configured threshold.
 * Keeps its count in sync via the theme's cartUpdate pub/sub event, and opens the cart
 * drawer by delegating to the header cart icon (falls back to /cart if no drawer).
 * Markup + settings live in snippets/sticky-cart.liquid.
 */
(function () {
  var btn = document.getElementById('StickyCart');
  if (!btn) return;

  var countEl = btn.querySelector('[data-sticky-cart-count]');
  var threshold = parseInt(btn.dataset.threshold, 10) || 300;
  var itemCount = parseInt(btn.dataset.count, 10) || 0;

  // The button starts with [hidden]; remove it so CSS transitions can take over.
  btn.removeAttribute('hidden');

  function render() {
    var shouldShow = itemCount > 0 && window.scrollY > threshold;
    btn.classList.toggle('is-visible', shouldShow);
  }

  function setCount(value) {
    itemCount = value || 0;
    if (countEl) {
      countEl.textContent = itemCount > 99 ? '99+' : itemCount;
      countEl.hidden = itemCount === 0;
    }
    render();
  }

  window.addEventListener('scroll', render, { passive: true });

  // Open the cart the same way the header icon does (drawer if enabled, else /cart).
  btn.addEventListener('click', function () {
    var headerCart = document.getElementById('cart-icon-bubble');
    if (headerCart) {
      headerCart.click();
    } else if (window.routes && window.routes.cart_url) {
      window.location.href = window.routes.cart_url;
    }
  });

  // Refresh the count whenever the cart changes. Fetch /cart.js for an authoritative
  // item_count rather than relying on the varying cartUpdate payload shapes.
  function refreshFromServer() {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () { /* leave the existing count in place on failure */ });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshFromServer);
  }

  // Initial paint.
  setCount(itemCount);
})();
